<template>
  <div class="about">
    <Topmenu />
    <div class="subbanner pr">
      <img src="@/assets/banner_job.jpg" />
    </div>
    <div class="wrapcon" srtabs="true" style="width: 1100px">
      <div class="jobtab">
        <a
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ on: chooseindex == index }"
          @click="clickitem(index)"
        >
          {{ item.tabname }}
        </a>
      </div>
      <div class="contentbox" style="width: 99%">
        <div v-if="chooseindex == 0" class="intro">
          <h6 class="smalltit">岗位职责：</h6>
          <p>
            1、独立完成医院软件产品的安装、部署、配置等实施工作；<br />
            2、独立完成与医院信息系统的对接、数据采集核对工作； <br />
            3、完成对使用软件的医院人员的讲解和操作培训工作； <br />
            4、收集客户在使用软件产品过程中提出的问题和建议； <br />
            5、完成部门经理交办与实施相关的其他工作；
          </p>
          <h6 class="smalltit">任职资格：</h6>
          <p>
            1、本科及以上学历，信息技术相关专业优先，其他专业也可；<br />
            2、热爱软件技术，逻辑性强，有较好的钻研和学习能力； <br />
            3、能熟练编写MySQL、Oracle等常用数据库的SQL查询语句； <br />
            4、能接受长期出差的工作性质，基本每月可回来一次；
          </p>
          <h6 class="smalltit">薪资待遇：</h6>
          <p>
            一年工作经验者年收入<span class="boldred" style="font-size: 22px">7万</span>左右；<br />
            二年工作经验者年收入可达 <span class="boldred" style="font-size: 22px">8-9万</span>； <br />
            三年工作经验，优秀员工年收入在<span class="boldred" style="font-size: 22px">10万+</span>； <br />
            入职公司均提供五险一金、双休、年度旅游、年终奖金，表现优秀者，每年两次调薪。 <br />
            招聘人数：5人
          </p>
        </div>
        <div v-else-if="chooseindex == 1" class="intro">
          <h6 class="smalltit">岗位职责：</h6>
          <p>
            1、协助咨询经理做好服务医院的数据收集、分析等工作；<br />
            2、协助咨询经理做好服务医院的员工访谈工作； <br />
            3、协助咨询经理做好服务医院的日常工作； <br />
            4、协助咨询经理做好方案宣讲及后续讲解工作； <br />
            5、完成咨询经理交办的其他工作。
            <br />
          </p>
          <h6 class="smalltit">任职资格：</h6>
          <p>
            1、本科及以上学历，专业不限；<br />
            2、具有较强的沟通表达能力及学习能力； <br />
            3、具有亲和力和良好的职业形象； <br />
            4、能接受长期出差的工作性质； <br />
            5、熟练使用EXCEL、PPT等办公软件。
          </p>
          <h6 class="smalltit">薪资待遇：</h6>
          <p>
            一年工作经验者年收入<span class="boldred" style="font-size: 22px">6-7万</span>左右；<br />
            二年工作经验者年收入可达 <span class="boldred" style="font-size: 22px">8-10万</span>； <br />
            三年工作经验优先，员工年收入在<span class="boldred" style="font-size: 22px">12万-15万</span>； <br />
            入职公司均提供五险一金、双休、年度旅游、年终奖金，表现优秀者，每年两次调薪。 <br />
            招聘人数：5人
          </p>
          <p class="red">
            注：本岗位出差期间公司负责食宿，项目结束后回家休息，回公司汇报期间公司提供宿舍，不需要考虑住宿问题。 <br />
          </p>
        </div>
        <div v-else-if="chooseindex == 2" class="intro">
          <h6 class="smalltit">岗位职责：</h6>
          <p>
            1、负责公司项目的开发工作；<br />
            2、负责项目的需求评审及修改； <br />
            3、负责项目的上线工作； <br />
            4、负责领导交办的其他工作。
            <br />
          </p>
          <h6 class="smalltit">任职资格：</h6>
          <p>
            1、本科及以上学历，计算机相关专；<br />
            2、具备扎实的Java基础，能熟练使用Eclipse等编程工具进行开发； <br />
            3、熟悉Struts、Spring、Hibernate等流行框架进行Web系统开发，熟悉JavaScript，熟悉JQuery等前端类库； <br />
            4、掌握数据库基础知识，熟练使用一种或多种关系型数据库，熟练使用SQL语句，对数据库进行操作与应用，熟悉Oracle者优先；
            <br />
            5、熟悉Tomcat等常用应用服务器，能够自己进行系统部署、调测，熟悉Weblogic者优先； <br />
            6、熟悉Linux、Unix系统常用命令者优先； <br />
            7、热爱软件技术，逻辑性强，有较好的钻研和学习能力，善于沟通，有团队意识。
            <br />
          </p>
          <h6 class="smalltit">薪资待遇：</h6>
          <p>
            一年工作经验者年收入<span class="boldred" style="font-size: 22px">5-7万</span>左右； <br />
            入职公司均提供五险一金、双休、年度旅游、年终奖金，表现优秀者，每年两次调薪。 <br />
            招聘人数：5人
          </p>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
<script>
import Topmenu from '@/components/topmenu'
import Bottom from '@/components/bottom'
export default {
  name: 'About',
  components: {
    Topmenu,
    Bottom
  },
  data() {
    return {
      chooseindex: 0,
      tabList: [{ tabname: '软件实施人员' }, { tabname: '咨询助理' }, { tabname: '软件开发工程师' }]
    }
  },
  methods: {
    clickitem(index) {
      this.chooseindex = index
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapcon {
  width: 1200px;
  margin: 10px auto;
  overflow: hidden;
  padding-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
/*招聘信息选项卡*/
.jobtab {
  width: 840px;
  height: 70px;
  margin: 20px auto 0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}
.jobtab a {
  display: block;
  text-align: center;
  line-height: 70px;
  width: 33.3333%;
  float: left;
  font-size: 22px;
  cursor: pointer;
}
.jobtab a.on,
.tab a:hover {
  background: url(../assets/job-type-bg.jpg) no-repeat bottom;
  background-size: 100%;
  color: #fff;
  border-radius: 5px;
}

.contentbox {
  margin: 0 auto;
  background: url(../assets/combg.jpg) no-repeat 450px 0;
}
</style>
